<template>
  <customers-table />
</template>

<script setup lang="ts">
import CustomersTable from "@/modules/Customers/CustomersTable/CustomersTable.vue";
import { useI18n } from "vue-i18n";
import { EXTERNAL_DOCS_LINKS } from "@/constants/externalDocsLinks.ts";
import { useAuthenticationStore } from "@/store/authentication.store";
import { usePageMetaStore } from "@/store/pageMeta.store";
import { useRoute } from "vue-router";
import { watch } from "vue";

const { t } = useI18n();
const route = useRoute();
const pageMetaStore = usePageMetaStore();
const authStore = useAuthenticationStore();

pageMetaStore.setPageTitle({
  title: t("customers"),
  info: {
    docsLink: EXTERNAL_DOCS_LINKS.MSP_CUSTOMERS_OVERVIEW,
    text: t("customer-page"),
  },
});

watch(
  () => route.params.id,
  (orgId) => {
    if (typeof orgId === "string" && orgId.length) {
      authStore.setMspUser({
        uuid: orgId,
        name: "",
      });
    }
  },
  { immediate: true },
);
</script>
